<template>
  <div id="app" :class="(numberShow === indexNumber && !longImage) || isSearch === true ? 'index' : ''"
       :style="longImage ? 'overflow-y: hidden;' : ''">
    <SearchDialog class="report" :show.sync="isSearch" v-if="isSearch"></SearchDialog> <!-- 聚合搜索 -->
    <Index v-if="numberShow === indexNumber"/><!-- 可视化财报 -->
    <album v-else-if="numberShow === albumNumber || numberShow === albumNumber + 9"/><!-- 电子相册 -->
    <error ref="errorRef" v-else></error><!-- 异常页面 -->
  </div>
</template>

<script>
import Index from './views/index.vue'
import Album from './views/album.vue'
import Error from '@/components/error.vue'
import SearchDialog from "./components/SearchDialog.vue";

export default {
  name: 'app',
  components: {SearchDialog, Index, Album, Error},
  data() {
    return {
      numberShow: 0,
      indexNumber: 36,
      albumNumber: 42,
      showError: false,
      longImage: false,
      appConfig: {},
      isSearch: false,
    }
  },
  mounted() {
    const script = document.createElement('script');
    script.src = './../base.env.js';
    document.body.appendChild(script);
    // 等待脚本加载完成后再访问对象
    script.onload = () => {
      console.log(envConfig);
      this.appConfig = envConfig;
      this.$store.commit('setEnvConfig', this.appConfig); // 将参数放入store

      let url = window.location.href
      if (url.indexOf('?') === -1 || !url.split('?')[1]) {
        // this.openAlert('路径或者名称有误，请检查后重新输入')
        // return
        this.isSearch = true;
      }else{
        if (url.indexOf("=#") !== -1) { // 解决微信转发的问题
          url = url.replace("=#", "#");
        }
        const paramLen = url.split('?')[1].length
        if (paramLen === 32 || paramLen === 45 || url.endsWith('.json') || url.endsWith('.img')) { // 财报预览（redis） img为导出长图
          this.numberShow = this.indexNumber
          this.longImage = url.endsWith('.img')
        } else if (paramLen === this.indexNumber) { // 财报查看（文件）
          this.numberShow = paramLen
        } else if (paramLen === this.albumNumber || paramLen === this.albumNumber + 9) { // 电子相册（文件）
          this.numberShow = paramLen
        } else { // 异常页
          this.showError = true
        }
        this.$refs.errorRef.isLoading = false;
      }
    }
  },
  methods: {
    openAlert(msg) {
      this.$alert(msg, '', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.showError = true
          }
        },
      })
    },
  },
}
</script>

<style scoped>
/* 引入思源黑体 */
@font-face {
  font-family: 'SourceHanSansCN';
  src: url('~@/assets/fonts/SourceHanSansCN-Regular.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

/* 引入思源宋体 */
@font-face {
  font-family: 'SourceHanSerifCN';
  src: url('~@/assets/fonts/SourceHanSerifCN-Regular-1.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: 'SourceHanSansCN', 'SourceHanSerifCN', sans-serif;
}

.index {
  display: flex;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-image: var(--bgImg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.report {
  width: 1140px;
  height: 720px;
  position: relative;
}
</style>
